export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_ODC_USER_SUCCESS = 'DELETE_ODC_USER_SUCCESS';
export const GET_MORE_USERS_REQUEST = 'GET_MORE_USERS_REQUEST';
export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_ODC_USERS_REQUEST = 'GET_ODC_USERS_REQUEST';
export const GET_ODC_USERS_SUCCESS = 'GET_ODC_USERS_SUCCESS';
export const GET_ODC_USERS_FAILURE = 'GET_ODC_USERS_FAILURE';
export const RESET_ODC_USERS_STATE = 'RESET_ODC_USERS_STATE';
export const RESET_ODC_USER_STATE = 'RESET_ODC_USER_STATE';
export const GET_MORE_USERS_SUCCESS = 'GET_MORE_USERS_SUCCESS';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_ODC_USER_SUCCESS = 'GET_ODC_USER_SUCCESS';
export const GET_ODC_USER_FAILURE = 'GET_ODC_USER_FAILURE';
export const UPDATE_USER_ROLE_REQUEST = 'UPDATE_USER_ROLE_REQUEST';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';
export const UPDATE_USER_ROLE_FAILURE = 'UPDATE_USER_ROLE_FAILURE';
export const RESET_EMPLOYEE_STATE = 'RESET_EMPLOYEE_STATE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SET_USER_SEARCH = 'SET_USER_SEARCH';

export type DELETE_USER_REQUEST = typeof DELETE_USER_REQUEST;
export type DELETE_ODC_USER_SUCCESS = typeof DELETE_ODC_USER_SUCCESS;
export type GET_MORE_USERS_REQUEST = typeof GET_MORE_USERS_REQUEST;
export type GET_USERS_REQUEST = typeof GET_USERS_REQUEST;
export type GET_USERS_SUCCESS = typeof GET_USERS_SUCCESS;
export type GET_ODC_USERS_REQUEST = typeof GET_ODC_USERS_REQUEST;
export type GET_ODC_USERS_SUCCESS = typeof GET_ODC_USERS_SUCCESS;
export type GET_ODC_USERS_FAILURE = typeof GET_ODC_USERS_FAILURE;
export type RESET_ODC_USERS_STATE = typeof RESET_ODC_USERS_STATE;
export type RESET_ODC_USER_STATE = typeof RESET_ODC_USER_STATE;
export type GET_MORE_USERS_SUCCESS = typeof GET_MORE_USERS_SUCCESS;
export type GET_USER_SUCCESS = typeof GET_USER_SUCCESS;
export type GET_ODC_USER_SUCCESS = typeof GET_ODC_USER_SUCCESS;
export type GET_ODC_USER_FAILURE = typeof GET_ODC_USER_FAILURE;
export type UPDATE_USER_ROLE_REQUEST = typeof UPDATE_USER_ROLE_REQUEST;
export type UPDATE_USER_ROLE_SUCCESS = typeof UPDATE_USER_ROLE_SUCCESS;
export type UPDATE_USER_ROLE_FAILURE = typeof UPDATE_USER_ROLE_FAILURE;
export type RESET_EMPLOYEE_STATE = typeof RESET_EMPLOYEE_STATE;
export type LOGOUT_SUCCESS = typeof LOGOUT_SUCCESS;
export type SET_USER_SEARCH = typeof SET_USER_SEARCH;
